/**
 * Large Abako logo for the center of the auth layout.
 * Renders the full green Abako mark at ~350px.
 */
export function AbakoLogoLarge() {
  return (
    <svg
      width="304"
      height="304"
      viewBox="0 0 304 304"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M129.188 281.034C57.8419 268.518 10.15 200.534 22.6653 129.188C23.5119 124.362 24.6126 119.643 25.951 115.045C29.1402 104.088 48.5027 107.93 55.0662 117.265C63.7927 129.676 77.2478 138.764 93.3726 141.592C125.668 147.257 156.442 125.669 162.108 93.3727C164.936 77.2479 160.971 61.5031 152.271 49.0733C145.727 39.7244 148.705 20.2105 160.093 20.941C164.873 21.2475 169.683 21.8184 174.51 22.665C245.856 35.1803 293.549 103.163 281.034 174.51C280.095 179.863 278.843 185.083 277.302 190.154C274.102 200.68 256.666 197.728 250.273 188.775C241.54 176.546 228.188 167.605 212.218 164.803C179.922 159.138 149.148 180.726 143.483 213.022C140.682 228.992 144.545 244.59 153.071 256.964C159.314 266.023 156.155 283.423 145.169 282.849C139.876 282.573 134.541 281.973 129.188 281.034ZM33.1983 127.783C33.181 127.868 33.1645 127.954 33.1473 128.039C33.1645 127.954 33.181 127.868 33.1983 127.783ZM32.9444 129.078C32.9243 129.182 32.9021 129.287 32.8823 129.392C32.8691 129.462 32.8575 129.532 32.8444 129.602C32.8771 129.427 32.9109 129.252 32.9444 129.078ZM32.6024 130.937C32.5254 131.376 32.4514 131.815 32.3794 132.253C32.4513 131.815 32.5254 131.376 32.6024 130.937ZM32.288 132.825C32.2363 133.15 32.1851 133.474 32.136 133.799C32.1851 133.474 32.2363 133.15 32.288 132.825Z"
        fill="url(#paint0_linear_3719_53)"
      />
      <path
        d="M164.017 216.623C167.692 195.668 187.66 181.661 208.615 185.337C229.57 189.013 243.577 208.98 239.901 229.935C236.225 250.89 216.258 264.897 195.303 261.221C174.348 257.545 160.341 237.578 164.017 216.623Z"
        fill="var(--colors-cyan-600)"
      />
      <path
        d="M65.688 76.4585C69.3638 55.5036 89.331 41.4961 110.286 45.1719C131.241 48.8478 145.248 68.8149 141.572 89.7699C137.897 110.725 117.929 124.732 96.9746 121.056C76.0196 117.381 62.0121 97.4135 65.688 76.4585Z"
        fill="var(--colors-emerald-500)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3719_53"
          x1="44.742"
          y1="-1.95335"
          x2="259.273"
          y2="303.852"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--colors-emerald-500)" />
          <stop offset="1" stop-color="var(--colors-cyan-600)" />
        </linearGradient>
      </defs>
    </svg>
  );
}
